import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAdminAxiosInterceptors } from "@/lib/adminAuth";

// Install the admin auth interceptor at startup so it's active no matter which
// page (including a deep-linked /admin/* page) loads first.
installAdminAxiosInterceptors();

// Hydrate when the HTML was pre-rendered by react-snap (so static SEO HTML is
// reused), otherwise mount normally.
const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
